import * as React from "react";
import autobind from "autobind-decorator";
import {Store} from "./store";
import {observer} from "mobx-react";
import {
  ControlWrapper,
  ControlButton,
  ControlPageCount,
} from "./components";

interface Props<T> {
  store: Store<T>;
  onPageChange?: (page: number) => void;
}

@observer
export class ProtableControls<T> extends React.Component<Props<T>> {

  constructor(props: Props<T>) {
    super(props);
    this.state = {};
  }

  changePage = (forward: boolean) => {
    const { store, onPageChange } = this.props;
    const s = store.s;
    if (forward) {
      if (s.page + 1 <= store.totalPages) {
        const page = s.page + 1;
        if (onPageChange) onPageChange (page);
        store.setPage(page);
      }
    }
    else if (s.page - 1 >= 1) {
      const page = s.page - 1;
      if (onPageChange) onPageChange (page);
      store.setPage(page);
    }
  }

  setFirstPage = () => {
    const { store, onPageChange } = this.props;
    const s = store.s;
    if (s.page !== 1) {
      if (onPageChange) onPageChange (1);
      store.setPage(1);
    }
  }

  setLastPage = () => {
    const { store, onPageChange } = this.props;
    const s = store.s;
    if (s.page !== store.totalPages) {
      if (onPageChange) onPageChange (store.totalPages);
      store.setPage(store.totalPages);
    }
  }

  render() {
    const { store } = this.props;
    const s = store.s;
    return (
      <ControlWrapper>
        <ControlButton onClick={this.setFirstPage}>First</ControlButton>
        <ControlButton onClick={() => this.changePage(false)}>Previous</ControlButton>
        <ControlPageCount>{s.page} / {store.totalPages}</ControlPageCount>
        <ControlButton onClick={() => this.changePage(true)}>Next</ControlButton>
        <ControlButton onClick={this.setLastPage}>Last</ControlButton>
      </ControlWrapper>
    );
  }

}
